const POSITION_COORDS = {
  "right-wing": { x: 82, y: 22 },
  "left-wing": { x: 18, y: 22 },
  "centre-forward": { x: 50, y: 12 },
  "striker": { x: 50, y: 12 },
  "second-striker": { x: 50, y: 24 },
  "attacking-midfield": { x: 50, y: 36 },
  "right-attacking-midfield": { x: 74, y: 34 },
  "left-attacking-midfield": { x: 26, y: 34 },
  "central-midfield": { x: 50, y: 52 },
  "right-midfield": { x: 82, y: 50 },
  "left-midfield": { x: 18, y: 50 },
  "defensive-midfield": { x: 50, y: 64 },
  "right-back": { x: 84, y: 80 },
  "left-back": { x: 16, y: 80 },
  "centre-back": { x: 50, y: 86 },
  "goalkeeper": { x: 50, y: 96 },
};

export default function ReportPositionPitch({ code, mainLabel, otherLabel }) {
  const coord = POSITION_COORDS[code] || { x: 50, y: 40 };

  return (
    <div className="pr-position-card">
      <h3 className="pr-card-title">Position</h3>
      <svg viewBox="0 0 100 100" className="pr-pitch-mini" role="img" aria-label="Position on pitch">
        <rect x="4" y="4" width="92" height="92" className="pr-mini-outline" />
        <line x1="4" y1="50" x2="96" y2="50" className="pr-mini-line" />
        <circle cx="50" cy="50" r="10" className="pr-mini-line" fill="none" />
        <rect x="26" y="4" width="48" height="16" className="pr-mini-line" fill="none" />
        <rect x="26" y="80" width="48" height="16" className="pr-mini-line" fill="none" />
        <circle cx={coord.x} cy={coord.y} r="4.2" className="pr-mini-dot" />
      </svg>
      <div className="pr-mini-legend">
        <div>
          <span className="pr-mini-legend-label">Main</span>
          <span className="pr-mini-legend-value">{mainLabel}</span>
        </div>
        {otherLabel && (
          <div>
            <span className="pr-mini-legend-label">Other</span>
            <span className="pr-mini-legend-value">{otherLabel}</span>
          </div>
        )}
      </div>
    </div>
  );
}
